var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "b-toggle",
          rawName: "v-b-toggle",
          value: _vm.disableControl
            ? null
            : "notification-group-collapse-" + _vm.groupKey,
          expression:
            "disableControl ? null : 'notification-group-collapse-'+groupKey"
        }
      ],
      staticClass: "collapse-control notification-collapse-narrow",
      class: [
        "notification-group-collapsible-" + _vm.groupKey,
        _vm.disableControl ? "disabled-collapse" : ""
      ],
      style: _vm.disableControl ? { pointerEvents: "none", opacity: 0.5 } : {},
      on: { click: _vm.toggle }
    },
    [
      _c("div", { staticClass: "task-exp" }, [
        !_vm.expanded
          ? _c("span", [
              _c("span", { staticClass: "notification-count" }, [
                _vm._v("+" + _vm._s(_vm.unreadCount) + " New")
              ]),
              _vm._v(" "),
              _vm._m(0)
            ])
          : _c("span", [
              _c("span", { staticClass: "notification-close-text" }, [
                _vm._v("CLOSE")
              ]),
              _vm._v(" "),
              _vm._m(1)
            ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "task-exp exp-mobile" }, [
        !_vm.expanded ? _c("span", [_vm._m(2)]) : _c("span", [_vm._m(3)])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("img", {
        attrs: { src: require("@/csmworkflow/img/chevron-down.svg") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon close-collase" }, [
      _c("img", { attrs: { src: require("@/csmworkflow/img/chevron-up.svg") } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("img", {
        attrs: { src: require("@/csmworkflow/img/chevron-down.svg") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("span", { staticClass: "icon close-collase" }, [
        _c("img", {
          attrs: { src: require("@/csmworkflow/img/chevron-up.svg") }
        })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }